/* eslint-disable import/prefer-default-export */
/**
 * @param token
 * @returns an object { userName, userRole }
 */
export const decodeToken = (token: string) => {
  const encodedString = token.split('.')[1];
  const decodedToken = JSON.parse(atob(encodedString));
  return {
    userName: decodedToken.sub,
    userRoles: decodedToken.authorities,
    company: decodedToken.employerName,
    applications: decodedToken.applications,
  };
};
